import moment from 'moment';
import type OrderItem from '@this/domain/order_item2';
import { Fetcher } from '@this/src/util';

interface UpdateOrderItemWaitingResponse {
  updated_at: string;
}

export const updateOrderItemWaiting = async (orderItem: OrderItem, waiting: boolean): Promise<void> => {
  const response = await Fetcher.put<UpdateOrderItemWaitingResponse>(
    `/arrangement/order_items/${orderItem.id}/update_waiting`,
    { waiting }
  );
  orderItem.waiting = waiting;
  orderItem.updatedAt = moment(response.updated_at);
};
